import React from 'react';
import PropTypes from 'prop-types';
import Toggle from 'react-toggle';
import { INSTALL_ADMIN, INSTALL_USER } from '../../../config/app_config';
import { storeWithExpiration } from '../../../utils/common';
import AddUserForm from './AddUserForm';
import DialogForm from '../../shared/DialogForm';

const DELETE_INSTALL_USER_DIALOG = 'deleteInstallUserDialog';
const fieldDisplayNames = ['User', 'Role', 'Active', 'Delete'];

export default class ManageUsers extends React.Component {
  static propTypes = {
    getInstallationUsersFunction: PropTypes.func.isRequired,
    closeDialogFunction: PropTypes.func.isRequired,
    currentUser: PropTypes.object.isRequired,
    data: PropTypes.object.isRequired,
    deleteInstallUserFunction: PropTypes.func.isRequired,
    dialog: PropTypes.object.isRequired,
    installId: PropTypes.string.isRequired,
    installUsers: PropTypes.object,
    inviteUserFunction: PropTypes.func.isRequired,
    openDialogFunction: PropTypes.func.isRequired,
    setStatusFunction: PropTypes.func.isRequired,
  };

  static defaultProps = {
    installUsers: null,
  };

  state = {
    userId: null,
  };

  componentWillMount = () => {
    const { getInstallationUsersFunction, installId } = this.props;
    const token = storeWithExpiration.get('token');

    getInstallationUsersFunction(installId, token);
  };

  toggleDialog = id => {
    const { dialog, openDialogFunction, closeDialogFunction } = this.props;
    if (dialog.show && dialog.id === DELETE_INSTALL_USER_DIALOG) {
      closeDialogFunction(id);
    } else {
      openDialogFunction(id, 1);
    }
  };

  cancelDialog = id => {
    const { closeDialogFunction } = this.props;
    closeDialogFunction(id);
  };

  verifyDeleteUser = (userId, userName, evt) => {
    evt && evt.preventDefault();

    this.setState({ userId }, () => {
      this.setState({ userName }, () => {
        this.toggleDialog(DELETE_INSTALL_USER_DIALOG);
      });
    });
  };

  deleteUser = () => {
    const { data, deleteInstallUserFunction, installUsers } = this.props;
    const { userId } = this.state;
    const { installation: { id } } = data;
    const token = storeWithExpiration.get('token');
    // get installationUser by id
    const user = installUsers
      .filter(userObj => userObj.installationUser.get('id') === userId)
      .first()
      .installationUser.toObject();
    deleteInstallUserFunction(user, id, token);
    this.toggleDialog(DELETE_INSTALL_USER_DIALOG);
  };

  handleInviteUserSubmit = params => {
    const { data, inviteUserFunction } = this.props;
    const { installation: { id } } = data;
    const token = storeWithExpiration.get('token');
    const email = params.email.trim();
    const permission = params.permission ? INSTALL_ADMIN : INSTALL_USER;

    inviteUserFunction(id, token, email, permission);
  };

  handleVerifyDeleteUser = (rowUserId, userName) => evt => {
    this.verifyDeleteUser(rowUserId, userName, evt);
  };

  handleActiveChange = (value, userId) => () => {
    const { data, installUsers, setStatusFunction } = this.props;
    const token = storeWithExpiration.get('token');
    const { installation: { id } } = data;
    const user = installUsers
      .filter(userObj => userObj.installationUser.get('id') === userId)
      .first()
      .installationUser.toObject();
    user.status = value ? 0 : 1;

    setStatusFunction(user, id, token);
  };

  renderUsers = (user, index) => (
    <tr key={index}>
      {fieldDisplayNames.map(name => (
        <td key={name} className={user.matched ? 'already-matched' : null}>
          {this.renderUserData(name, user)}
        </td>
      ))}
    </tr>
  );

  renderUserData = (name, user) => {
    const { currentUser } = this.props;
    const value = user[name];
    const rowUserId = user.installUserId;
    const isCurrentUser = currentUser.get('id') === user.userId;
    const userName = user.User;
    const isAdmin = user.Role === INSTALL_ADMIN;
    let renderedItem = value;

    switch (name) {
      case 'Delete':
        renderedItem = (
          <button
            className="btn-icon"
            onClick={this.handleVerifyDeleteUser(rowUserId, userName)}
            disabled={isAdmin || isCurrentUser}
            style={{ marginLeft: '1rem' }}
          >
            <i className="fa fa-trash" />
          </button>
        );
        break;
      case 'Active':
        renderedItem = (
          <Toggle
            checked={value}
            disabled={isCurrentUser}
            onChange={this.handleActiveChange(value, rowUserId)}
          />
        );
        break;
      default:
        break;
    }

    return renderedItem;
  };

  renderDialog = () => {
    const { userName } = this.state;
    const { dialog } = this.props;
    const dialogContent = (
      <div className="container">
        <p>
          You are about to delete {userName} from this install.
          <br />
          <br />
          Proceed?
        </p>
        <br />
        <button className="btn btn-primary pull-right" onClick={this.deleteUser}>
          Okay
        </button>
        <button
          style={{ marginRight: '1rem' }}
          className="btn btn-secondary pull-right"
          onClick={this.cancelDialog}
        >
          Cancel
        </button>
        <br />
      </div>
    );

    return (
      <DialogForm
        cancelFunction={this.cancelDialog}
        content={dialogContent}
        id={DELETE_INSTALL_USER_DIALOG}
        show={dialog.show}
        title="Delete User"
      />
    );
  };

  render() {
    const { data, dialog, installUsers } = this.props;

    // First pass might not have installUsers so don't render
    if (!installUsers) return null;

    const { installation } = data;
    const name = installation.get('description');
    const items = installUsers.valueSeq().map(install => {
      const { user } = install;
      const installUser = install.installationUser; // don't want to redeclare installationUser
      let userName = user.get('email');
      if (user.get('firstName') !== null) {
        userName = user.get('firstName');
        if (user.get('lastName') !== null) userName += ` ${user.get('lastName')}`;
      }
      const permLevel = installUser.get('permissions');
      const isActive = installUser.get('status') === 1;
      const installUserId = installUser.get('id');
      const userId = user.get('id');
      return {
        User: userName,
        Role: permLevel,
        Active: isActive,
        Delete: null,
        userId,
        installUserId,
      };
    });

    return (
      <div className="modal-wrap">
        <div className="row row-top">
          <div className="col-xs-12">
            <h1>Manage Users</h1>
          </div>
        </div>
        <div className="container container-home">
          <div className="row">
            <div className="col-sm-12">
              <h4>{name}</h4>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12">
              <table className="table">
                <thead>
                  <tr>
                    {fieldDisplayNames.map(displayName => <th key={displayName}>{displayName}</th>)}
                    <th />
                  </tr>
                </thead>
                <tbody>{items.map(this.renderUsers)}</tbody>
              </table>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12">
              <AddUserForm submitFunction={this.handleInviteUserSubmit} />
            </div>
          </div>
        </div>
        {dialog.id === DELETE_INSTALL_USER_DIALOG && dialog.show ? this.renderDialog() : null}
      </div>
    );
  }
}
